// extracted by mini-css-extract-plugin
export default {"mobileHeight":"screen and (max-height: 824px)","header":"MobileSearchHeader_header__9O19P","col":"MobileSearchHeader_col__1yKDf","logo":"MobileSearchHeader_logo__elYy9"};